import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminUsage() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/usage").then((r) => setRows(r.data)); }, []);
  return (
    <div data-testid="admin-usage-page" className="space-y-4">
      <h1 className="font-display font-extrabold text-3xl">Platform usage</h1>
      <div className="hs-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F3F4F6] text-[11px] uppercase font-mono text-[#4B5563]">
            <tr><th className="text-left px-4 py-3">Type</th><th className="text-right px-4 py-3">Events</th><th className="text-right px-4 py-3">Tokens</th><th className="text-right px-4 py-3">Credits</th></tr>
          </thead>
          <tbody>
            {rows.length === 0 && (<tr><td colSpan={4} className="px-4 py-6 text-sm text-[#4B5563] text-center">No usage yet.</td></tr>)}
            {rows.map((r) => (
              <tr key={r.type} className="border-t border-[#E2E8F0]" data-testid={`usage-row-${r.type}`}>
                <td className="px-4 py-3">{r.type}</td>
                <td className="px-4 py-3 text-right font-mono">{r.events}</td>
                <td className="px-4 py-3 text-right font-mono">{r.tokens}</td>
                <td className="px-4 py-3 text-right font-mono">{r.credits}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
